import { CarrierAndServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as z from "zod";
import { null as zNull } from "zod";

export const getTeamCarrierServiceOptions = {
  name: "getTeamCarrierServiceOptions" as const,
  input: zNull(),
  output: z.object({ options: z.array(CarrierAndServiceSchema) }),
};
